import { createReducer, on } from '@ngrx/store';
import {
	myPremiumInitialState,
	paymentIntentInitialState,
	// myPremiumAdapter,
	// myPremiumInitialState,
	premiumCheckTokenAdapter,
	premiumCheckTokenInitialState,
	premiumCouponInitialState,
	premiumDiscountListAdapter,
	premiumDiscountListInitialState,
	premiumModulesAdapter,
	premiumModulesInitialState
} from './extra.entity';
import {
	checkCodiceScontoFailure,
	checkCodiceScontoSuccess,
	checkErrorCodiceScontoSuccess,
	clearErrorToken,
	confirmSubscriptionSuccess,
	createCouponSuccess,
	intentSubscriptionSuccess,
	loadDiscountTypeFailure,
	loadDiscountTypeSuccess,
	loadPremiumModulesFailure,
	loadPremiumModulesSuccess,
	loadUserPremiumFailure,
	loadUserPremiumSuccess,
  setPaymentStatus
} from './extra.actions';
import { setPremiumInStore } from '../user/user.actions';

// export const premiumInitialState: PremiumState = {
// 	premiumModulesList: premiumModulesInitialState,
// 	premiumCheckToken: premiumCheckTokenInitialState,
// 	myPremium: myPremiumInitialState,
// 	premiumDisconutTypeList: premiumDiscountListInitialState,
// 	premiumCoupon: premiumCouponInitialState
// };

export const premiumModulesList = createReducer(
	premiumModulesInitialState,
	on(loadPremiumModulesSuccess, (state, action) =>
  // premiumModulesAdapter.setAll(action.premiumModules, state)
  {
    if(action.premiumModules && action.premiumModules.length > 0){
		return premiumModulesAdapter.setAll(action.premiumModules, state)
    }else {
      return premiumModulesAdapter.getInitialState({error: undefined})
    }
  }
	),
	on(loadPremiumModulesFailure, (state, action) => ({
		...state,
		error: action.error
	})),
	on(checkCodiceScontoSuccess, (state, action) =>
		premiumModulesAdapter.setAll(action.codiceScontoCheck, state)
	),
	on(checkCodiceScontoFailure, (state, action) => ({
		...state,
		error: action.error
	}))
);

export const premiumCheckToken = createReducer(
	premiumCheckTokenInitialState,
	on(clearErrorToken, (state) => ({ ...premiumCheckTokenInitialState })),
	on(checkErrorCodiceScontoSuccess, (state, action) =>
		premiumCheckTokenAdapter.setOne(action.codiceScontoCheck, state)
	)
);

// export const myPremium = createReducer(
// 	myPremiumInitialState,
// 	on(loadUserPremiumSuccess, (state, action) => myPremiumAdapter.setOne(action.myPremium, state)),
// 	on(loadUserPremiumFailure, (state, action) => ({
// 		...state,
// 		error: action.error
// 	}))
// );

export const premiumDisconutTypeList = createReducer(
	premiumDiscountListInitialState,
	on(loadDiscountTypeSuccess, (state, action) =>
		premiumDiscountListAdapter.setAll(action.discountType, state)
	),
	on(loadDiscountTypeFailure, (state, action) => ({
		...state,
		error: action.error
	}))
);

export const premiumCoupon = createReducer(
	premiumCouponInitialState,
	on(createCouponSuccess, (state, action) => ({
		...state,
		randomString: action.coupon.randomString
	}))
);

export const paymentIntent = createReducer(
	paymentIntentInitialState,
	on(intentSubscriptionSuccess, (state, action) => ({
		...state,
		completePaymentIntent: action.intentSubscriptionSuccess
	})),
	on(confirmSubscriptionSuccess, (state) => ({
		...state,
		paymentSuccess: true
	})),
  on(setPaymentStatus, (state,action) => ({
		...state,
		completePaymentIntent: {paymentIntent: action.paymentIntentStatus, stripeId:action.stripeId}
	})),
	on(setPremiumInStore, (state, {}) => ({
		...state,
		completePaymentIntent: undefined
	})),
  on(loadPremiumModulesSuccess, (state, action) =>({
		...state,
		paymentSuccess: false
	})),
);

export const myPremium = createReducer(
	myPremiumInitialState,
	on(loadUserPremiumSuccess, (state, action) => ({
		...state,
		premiumState: action.myPremium.premiumState,
		myModules: action.myPremium.myModules
	}))
);
